import { GoogleTranslateIcon } from './GoogleTranslateIcon';

/**
 * author: Google
 * id DFF485C3-0A13-4546-A267-7687AF1AB82F
 * name google-translate
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/google-translate.svg
 * tags
 * - Brand / Logo 
 */
export const GTranslateIcon = GoogleTranslateIcon;
export default GTranslateIcon